import { createI18n } from '../../functions';
import stationInfoText from './stationSelectionText';
import genericTableText from './genericTableText';
import searchInputText from './searchInputText';
import errorText from './errorText';
import banksText from './banksText';
import formText from './formText';
var i18n = createI18n({
    stationSelection: stationInfoText,
    genericTable: genericTableText,
    searchInput: searchInputText,
    error: errorText,
    banks: banksText,
    form: formText
});
export default i18n;
//# sourceMappingURL=i18n.js.map